import React from 'react';
import {Link} from "react-router-dom";
const PageInvalid = ({ }) => {

  return (
    <div className="questionBody">
      <div className="bubbleInactiveOverview"></div>
      <div className="bubbleActiveOverview">
          <div className="bubbleTextContentOverview">
          Bitte kehren Sie zur Startseite zurück um den Gültigen Token einzugeben.
          </div>
      <div>
        <Link to="/"><button className="btnToSurvey" >Zur Startseite</button></Link>
      </div>
      </div>
  </div>

  );
};

export default PageInvalid;
